//natives
import React from 'react';
import * as DateFns from 'date-fns';
import ptLocale from "date-fns/locale/pt-BR";
import Cookies from 'universal-cookie';

import Modal from '@material-ui/core/Modal';

import Tabela from '../childrens/tabela/.mixins';

import css from '../../../../../.mixins/styles';
const useStyles = css();

export default (props) => {
    const classes = useStyles();
    const obj_user = props.state.modalPDFUserData;
    const nome_file = props.state.dataAgenda+".pdf";
    const tempo = DateFns.format(new Date(),'dd/MM/yyyy HH:mm:ss',{locate: ptLocale});
    
    const cookies = new Cookies();
    const token = cookies.get('User-Token');

    const getModalStyle = () => {
        const top = 50;
        const left = 50;
    
        return {
            top: `${top}%`,
            left: `${left}%`,
            transform: `translate(-${top}%, -${left}%)`,
        };
    };

    const params = {
        classes: classes,
        obj_user: obj_user,
        nome_file: nome_file,
        tempo: tempo,
        token: token,
        dataAgenda: props.state.dataAgenda,
        data: props.state.itensTable
    }

    return (
        <Modal
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            open={props.state.modalPDF}
            onClose={props.handleClosePDF}
        >
            <div style={getModalStyle()} className={classes.paper}>
                <Tabela {...params}/>
            </div>
        </Modal>
    );
};